import { render, staticRenderFns } from "./HoraGeneral.vue?vue&type=template&id=4a4cccd6"
import script from "./HoraGeneral.vue?vue&type=script&lang=js"
export * from "./HoraGeneral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports